import axios from "axios";

export default () => {
  return axios.create({
	baseURL: `//vvcroom-portal.viettel.vn/api`
	//baseURL: `http://27.71.113.147:4005`
	
  });
};